export const debugLoggingEnabled =
  import.meta.env.DEV || import.meta.env.VITE_DEBUG_LOGS === 'true';

export function debugLog(...args: unknown[]) {
  if (debugLoggingEnabled) {
    console.log(...args);
  }
}
